//
// Module for the Batch Adjustment wizard Pay Component step
//
rs.module("jobs/criteria/batchadjustment/paycomponentstep",

    ["common/select-helper", "controls/components/event-banner"],

    function (selectHelper, eventBanner) {

        // Initialize the module
        function initialize(jsSelectors, codeValues, backendUrls) {

            var stepContainer = $.js(jsSelectors.stepContainer);
            var payComponentTypeSelect = stepContainer.js(jsSelectors.payComponentTypeSelect);
            var adjustmentCategorySelect = stepContainer.js(jsSelectors.adjustmentCategorySelect);
            var effectiveDateInput = stepContainer.js(jsSelectors.effectiveDateInput);
            var terminationDateInput = stepContainer.js(jsSelectors.terminationDateInput);
            var payComponentGridContainer = stepContainer.js(jsSelectors.payComponentGridContainer);
            var payComponentFilteredHidden = stepContainer.js(jsSelectors.payComponentFilteredHidden);
            var getAvailPayComponentsButton = stepContainer.js(jsSelectors.getAvailPayComponentsButton);
            var loadingSpinner = stepContainer.js(jsSelectors.loadingSpinner);
            
            // Get Select Helper for adjustmentCategorySelect since we're updating its options and properties
            var adjustmentCategorySelectHelper = selectHelper.getHelper(adjustmentCategorySelect);

            // On Pay Component Type change
            payComponentTypeSelect.change(function () {

                // enable/disable Adjustment Category
                if (payComponentTypeSelect.val() == codeValues.adjustment) {

                    adjustmentCategorySelectHelper.setDisabled(false).setValue(codeValues.cola);
                }
                else {
                    adjustmentCategorySelectHelper.setDisabled(true).setValue("");
                }

                // clear pay components grid
                clearPayComponentGrid();
            });

            // On Pay Component Type change
            adjustmentCategorySelect.change(function () {

                // clear pay components grid
                clearPayComponentGrid();
            });

            // On Effective Date change
            effectiveDateInput.change(_.debounce(function () {

                // clear pay components grid
                clearPayComponentGrid();
            }, 500));

            // On Termination Date change
            terminationDateInput.change(_.debounce(function () {

                // clear pay components grid
                clearPayComponentGrid();
            }, 500));

            // On Get Available Pay Components button click, display grid of retrieved available pay components
            getAvailPayComponentsButton.on("click", function (event) {

                // prevent the button from causing a post
                event.preventDefault();

                // clear any messages in the message banner
                eventBanner.removeAllMessages();

                // validate form and if valid, display partial grid of available pay components
                if (stepContainer.closest("form").valid()) {

                    loadingSpinner.show();

                    $.get(backendUrls.getPayComponentGrid,
                        {
                            payComponentType: payComponentTypeSelect.val(),
                            adjustmentCategory: adjustmentCategorySelect.val(),
                            effectiveDate: effectiveDateInput.val(),
                            terminationDate: terminationDateInput.val()
                        })
                        .showFieldErrors()
                        .done(function (html) {
                            payComponentGridContainer.html(html);
                            payComponentGridContainer.show();
                            payComponentFilteredHidden.val(true);
                        })
                        .always(function () {
                            loadingSpinner.hide();
                        });
                }
            });

            // Clear the pay components grid
            function clearPayComponentGrid() {
                if (payComponentGrid) {

                    payComponentGrid.clearGridRows();

                    // Get the wizard's next button and disable it 
                    var wizardNextButton = $(`[data-wizard]`).js("_next");
                    wizardNextButton.setDisabled();
                }
            }
        }

        // variable for accessing pay component grid
        var payComponentGrid;

        // Exported function used by module (_paycomponentstepgrid.js) to set payComponentGrid variable
        function setGrid(grid) {
            payComponentGrid = grid;
        }

        // Exported public API
        var exports = {
            initialize: initialize,
            setGrid: setGrid
        };

        return exports;
    }
);